<template>
  <div class="page">
    <div class="warning-view">
      <div
          class="scroll-view"
          ref="scrollViewRef"
          @mouseenter="onMouseenter"
          @mouseleave="onMouseleave"
      >
        <div ref="listRef" class="list" v-for="(p, n) in count" :key="n">
          <div class="item" v-for="(item, index) in data" :key="index">
            <slot :item="item" :index="index"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: ()=>[]
    },
    listType: {
      default: 'icon'
    },
  },
  data() {
    return {
      data: [], // 列表数据
      count: 1, // 列表个数
      intervalId: null,
      isAutoScrolling: true // 是否自动滚动标识
    };
  },
  watch: {
    list(val) {
      this.data = this.list
      this.$nextTick(() => {
        // 判断列表是否生成滚动条
        this.count = this.hasScrollBar() ? 2 : 1;
        // 有滚动条开始自动滚动
        if (this.count === 2) {
          this.autoScrolling();
        }
      });
    }
  },
  mounted() {
    this.data = this.list
    this.$nextTick(() => {
      // 判断列表是否生成滚动条
      this.count = this.hasScrollBar() ? 2 : 1;
      // 有滚动条开始自动滚动
      if (this.count === 2) {
        this.autoScrolling();
      }
    });
  },
  beforeDestroy() {
    // 离开页面清理定时器
    if (this.intervalId) clearInterval(this.intervalId);
  },
  methods: {
    hasScrollBar() {
      return this.$refs.scrollViewRef.scrollHeight > this.$refs.scrollViewRef.clientHeight;
    },
    autoScrolling() {
      this.intervalId = setInterval(() => {
        if (this.$refs.scrollViewRef.scrollTop < this.$refs.listRef[0].clientHeight) {
          this.$refs.scrollViewRef.scrollTop += this.isAutoScrolling ? 1 : 0;
        } else {
          this.$refs.scrollViewRef.scrollTop = 0;
        }
      }, 30);
    },
    onMouseenter() {
      this.isAutoScrolling = false;
    },
    onMouseleave() {
      this.isAutoScrolling = true;
    }
  }
};
</script>

<style scoped>
/* 样式部分保持不变 */
.page {
  width: calc(100% - 10px);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  /*color: #fff;*/
}
.warning-view {
  width: 100%;
  height: 100%;
  border: 1px solid #fff;
  display: flex;
  flex-direction: column;
}
.label {
  color: #fff;
  padding: 20px;
  font-size: 22px;
}
.scroll-view {
  flex: 1;
  height: 0;
  width: 100%;
  overflow-y: auto;
}
.list {
  width: 100%;
  /*padding: 0 20px;*/
  box-sizing: border-box;
}
.item {
  width: 100%;
  /*height: 50px;*/
  min-height: 40px;
  font-size: 16px;
  /*padding-left: 20px;*/
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*color: #eee;*/
}
/* 隐藏滚动条 */
::-webkit-scrollbar{
  display: none;
}
/* 隐藏所有浏览器中的滚动条 */
.scroll-view {
  overflow-y: scroll; /* 确保总是显示滚动条空间 */
}

/* 针对 WebKit 浏览器（Chrome, Safari等） */
.scroll-view::-webkit-scrollbar {
  display: none;
}

/* 针对 Firefox */
.scroll-view {
  scrollbar-width: none; /* Firefox 移除滚动条 */
}
</style>
